import parent from '../../api/parent'
export default {
    maintenanceList (req) {
        return parent.pms_post('api/store/maintenance/list',req)
    },
    boardData (req) {
        return parent.pms_post('api/store/work/board/query',req)
    }
}
